import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { FileMetadata } from "../types";

export type FailedUploadsLabels = {
    heading: string;
};

type FailedUploadsProps = {
    labels: FailedUploadsLabels;
    files: FileMetadata[];
    onDelete: (photoUploadMetadataId: number) => void;
};

export function FailedUploads({ labels, files, onDelete }: FailedUploadsProps) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h4">{labels.heading}</Typography>
            <List sx={{ width: '30%' }}>
                {files.map((file) => (
                    <ListItem
                        key={file.photoUploadMetadataId}
                        secondaryAction={
                            <IconButton 
                              edge="end" 
                              aria-label="delete"
                              onClick={() => onDelete(file.photoUploadMetadataId)}
                            >
                                <DeleteIcon />
                            </IconButton>
                        }
                    >
                        <ListItemText primary={file.filename} />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
}
